module.exports = __webpack_public_path__ + "img/Oeb-w-Logo.316c928.png";